import { createSvgIcon } from '@mui/material';

export const TerminateCardIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M21.775 18.925 20 17.15V12h-5.15l-4-4H20V6H8.85002l-2-2H20c.55 0 1.0209.19583 1.4125.5875C21.8042 4.97916 22 5.45 22 6v12c0 .1667-.0166.3292-.05.4875-.0333.1583-.0916.3042-.175.4375ZM9.15002 12h-5.15v6H15.15l-5.99998-6ZM20.45 23.3l-3.3-3.3H4.00002c-.55 0-1.02083-.1958-1.4125-.5875-.39166-.3917-.5875-.8625-.5875-1.4125V6c0-.55.19584-1.02084.5875-1.4125C2.97919 4.19583 3.45002 4 4.00002 4l2 2h-2v2h1.15L.650024 3.5 2.07502 2.075l19.79998 19.8L20.45 23.3Z"
    />
  </svg>,
  'TerminateCardIcon',
);
